import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { addVoucher } from 'Redux/ducks/voucher';
import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import SplashHeader from 'Components/Banner/SplashHeader';
import store, { history } from 'Redux/store';

import 'Components/ReferFriend/ReferralPage.scss';

const messages = defineMessages({
  title: {
    id: 'referral-page.title',
    defaultMessage: 'Referrals',
  },
  splash_header_title: {
    id: 'referral-page.spash_header.title',
    defaultMessage: 'You\'ve been referred',
  },
  splash_header_subtitle: {
    id: 'referral-page.spash_header.subtitle',
    defaultMessage: 'Get 5% off your next Fanatical order',
  },
});

const ReferralPage = ({
  intl: { formatMessage },
}) => {
  const [hasReferralLink, setHasReferralLink] = useState(false);

  let showReferral = false;
  const referralsEnd = '2023-07-01T00:00:00.000Z';
  if (Date.now() < Date.parse(referralsEnd)) showReferral = true;

  useEffect(() => {
    const { refer_a_friend: referralLink } = queryString.parse(history.location.search);
    if (referralLink) setHasReferralLink(true);
  }, []);

  const addVoucherAndNavigate = (code, navTo) => {
    store.dispatch(addVoucher(code, null, true));
    history.push(navTo);
  };

  return (
    <main className="referral-page">
      <Meta brandTitle title={formatMessage(messages.title)} />
      <NoIndex />
      <SplashHeader
        title={formatMessage(messages.splash_header_title)}
      />
      <section className="container-fluid">
        <div className="pt-5 pb-3 py-lg-5 container">
          <div className="coupon-button-container">
            <p className="sorry-message large-message">
              <FormattedMessage
                id="referral-page.not-active"
                defaultMessage="Please note as of the 1st July 2023 this 'Refer a friend' scheme is no longer active."
              />
            </p>
          </div>

          <div className="referral-title">
            <h2>
              <FormattedMessage id="referral-page.title.how-it-works" defaultMessage="How your referral works" />
            </h2>
          </div>
          <div className="brand-line my-3 mx-auto" />

          <div className="how-it-works-icons-container">
            <div className="referral-icon-container">
              <div className="referral-circle">
                <div className="step-icon">
                  <img
                    loading="lazy"
                    src="https://cdn.fanatical.com/production/icons/slim-icons/dark-icons/coupon-ticket.svg"
                    alt="Apply coupon"
                  />
                </div>
              </div>
              <p className="referral-circle-title">
                <FormattedMessage id="referral-page.signup" defaultMessage="Apply your coupon" />
              </p>
              <p className="referral-circle-subtitle">
                <FormattedMessage
                  id="referral-page.signup.subtitle"
                  defaultMessage="Start by clicking the button below to automatically apply your new user coupon to the cart."
                />
              </p>
            </div>

            <div className="chevron-container">
              <FontAwesomeIcon icon={faChevronRight} size="2x" className="referral-chevron" />
            </div>

            <div className="referral-icon-container">
              <div className="referral-circle">
                <div className="step-icon">
                  <img
                    loading="lazy"
                    src="https://cdn.fanatical.com/production/icons/slim-icons/dark-icons/store.svg"
                    alt="Browse store"
                  />
                </div>
              </div>
              <p className="referral-circle-title">
                <FormattedMessage id="referral-page.browse-fanatical" defaultMessage="Browse Fanatical" />
              </p>
              <p className="referral-circle-subtitle">
                <FormattedMessage
                  id="referral-page.browse-fanatical.subtitle"
                  defaultMessage="Next, browse the store to find your next game, comic or eBook. We specialise in bundles of them all. {link}"
                  values={{
                    link: <Link to="/blog/what-is-a-game-bundle-where-to-buy-them">
                      <FormattedMessage
                        id="referral-page.browse-fanatical.subtitle.link"
                        defaultMessage="You can find out more about bundles here."
                      />
                    </Link>,
                  }}
                />
              </p>
            </div>

            <div className="chevron-container">
              <FontAwesomeIcon icon={faChevronRight} size="2x" className="referral-chevron" />
            </div>

            <div className="referral-icon-container">
              <div className="referral-circle">
                <div className="step-icon cart-add">
                  <img
                    loading="lazy"
                    src="https://cdn.fanatical.com/production/icons/slim-icons/dark-icons/cart-add.svg"
                    alt="Add to cart"
                  />
                </div>
              </div>
              <p className="referral-circle-title">
                <FormattedMessage id="referral-page.basket" defaultMessage="Add to cart & create an account" />
              </p>
              <p className="referral-circle-subtitle">
                <FormattedMessage
                  id="referral-page.basket.subtitle"
                  defaultMessage="When you have found something you like, add it to your cart. Finally, proceed to checkout, create your account and that's it."
                />
              </p>
            </div>
          </div>

          {showReferral &&
            <div className="coupon-button-container">
              {hasReferralLink &&
                <button className="btn btn-primary btn-lg" onClick={() => addVoucherAndNavigate('Jc41aN636D0h1cdF', '/cart')}>
                  <FormattedMessage
                    id="referral-page.button.apply"
                    defaultMessage="Apply your coupon"
                  />
                </button>
              }

              {!hasReferralLink &&
                <p className="sorry-message">
                  <FormattedMessage
                    id="referral-page.coupon.sorry"
                    defaultMessage="Sorry, you must access this page via a referral link to get a coupon."
                  />
                </p>
              }
            </div>
          }

          <div className="referral-terms">
            <FormattedMessage
              id="referral-page.terms"
              defaultMessage="Terms and Conditions: Your 5% coupon cannot be used on Charity Bundles, Exclusive Cart Offers or Pre-Orders. It expires on 30th June 2023 at 22:59 (UTC) and can only be used on your first Fanatical order."
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default injectIntl(ReferralPage);
